import React, { useState } from "react";

import { Box, Tab, Tabs, Typography } from "@mui/material";

import PrimaryLayout from "../components/layout/PrimaryLayout";
import NamespacesList from "../views/namespaces-and-datasources/NamespacesList";
import DatasourcesList from "../views/namespaces-and-datasources/DatasourcesList";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const NamespacesAndDatasources = () => {
    const [value, setValue] = useState<number>(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <PrimaryLayout>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab label="Namespaces" {...a11yProps(1)} />
                    <Tab label="DataSources" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <Box sx={{ mx: 2, my: 2 }}>
                    <Typography variant="body1" color="text.secondary">
                        Use <strong>Namespaces</strong> to logically group and isolate workflows by function (e.g., Risk, Collections) or environment (e.g., Development, Staging, Production).
                        This helps enforce boundaries and organize deployments cleanly across teams or stages.
                    </Typography>
                </Box>
                <NamespacesList />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
                <Box sx={{ mx: 2, my: 2 }}>
                    <Typography variant="body1" color="text.secondary">
                        <strong>Data Sources</strong> are secure database connection configurations used by real-time DB Lookup blocks.
                        Define and manage credentials and connection settings here to ensure db accessibility at runtime.
                    </Typography>
                </Box>
                <DatasourcesList />
            </CustomTabPanel>
        </PrimaryLayout>
    )
};

export default NamespacesAndDatasources;
